module.exports = __webpack_public_path__ + "static/img17-f81e4c7e349fdf214a4d3100718a90da.jpg";